<dx-popup title="{{ 'Makros' | translate }}"
          [width]="1200"
          [height]="800"
          [dragEnabled]="false"
          [showTitle]="true"
          [showCloseButton]="true"
          [hideOnOutsideClick]="true"
          [(visible)]="visible"        
          [fullScreen]="fullScreen"
          contentTemplate="popupContent"
          enableBodyScroll="false">
  <dxi-toolbar-item *ngIf="fullScreen" toolbar="top" location="after" widget="dxButton" [options]="{ icon: 'chevrondown', onClick: toggleFullscren }"></dxi-toolbar-item>
  <dxi-toolbar-item *ngIf="!fullScreen" toolbar="top" location="after" widget="dxButton" [options]="{ icon: 'chevronup', onClick: toggleFullscren }"></dxi-toolbar-item>
  <dxi-toolbar-item toolbar="top" location="after" widget="dxDropDownButton">
    <np-help-button>
      <np-help-option text="Wiki" icon="images/Wiki.svg" link="https://knowledge.nextpim.de/makros?utm_source=app.nextpim.de&utm_medium=affiliate&utm_campaign=wikilink"></np-help-option>
      <np-help-option text="YouTube" icon="images/YouTube.svg" link="https://www.youtube.com/watch?v=gHtxkwiks9k"></np-help-option>
    </np-help-button>
  </dxi-toolbar-item>


  <div *dxTemplate="let data of 'popupContent'">
    <userAction [(macro)]="macro" [(parameter)]="parameter" [(editMode)]="editMode" (onMacroStart)="closePopUp()"  (onMacroSave)="saveMacro($event)" ></userAction>
  </div>
</dx-popup>
